import { BasecampRole } from "@utils/types";
import type { PropsWithChildren } from "react";

import { Button, Headline, Paragraph } from "@fronterahealth/frontera-ui-components";

import { useBasecampRoles } from "@hooks/useBasecampRoles";

export const NotAllowedPage: React.FC = () => {
  return (
    <div className="bg-inherit">
      <div className="flex flex-col items-center h-screen pt-16 bg-inherit">
        <Headline size="medium" className="mt-4">
          Oops, you don't have permission to access this page.
        </Headline>
        <Paragraph displayType="normal" colorType="secondary" className="text-center my-4">
          You can return to the homepage, or if you think something is broken you may report a problem.
        </Paragraph>
        <div className="flex space-x-2 pt-6">
          <Button
            appearance="primary"
            text="Return to Homepage"
            className="px-6"
            onClick={() => (window.location.href = "/")}
          />
          <Button
            appearance="secondary"
            className="px-6"
            text="Report a Problem"
            onClick={() => (window.location.href = "mailto:support@frontera.health")}
          />
        </div>
      </div>
    </div>
  );
};

interface AuthorizeProps extends PropsWithChildren {
  allowedRoles: BasecampRole[];
}

export const Authorize: React.FC<AuthorizeProps> = ({ allowedRoles, children }) => {
  const roles = useBasecampRoles();
  const authorized = allowedRoles.some((r) => roles.includes(r));

  if (!authorized) return <NotAllowedPage />;
  return <>{children}</>;
};
